export default [
  {
    path: '/testing-dashboard',
    name: 'testingDashboard',
    component: () => import('@views/singletons/TestingDashboard'),
    meta: {
      resourceOptional: true,
      secondaryRoute: true,
    },
  },
  {
    path: '/flashcard-state-explorer',
    name: 'flashcardStateExplorer',
    component: () => import('@views/singletons/FlashcardStateExplorer'),
    meta: {
      resourceOptional: true,
      secondaryRoute: true,
    },
  },
];
